<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Evaluación de atmósferas</h1>    
            <h2 class="animated bounceIn dura-2">Equipo de prueba de gases </h2>
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
        <span><strong>Preparación de áreas y equipos de proceso para la prueba de gases  </strong></span> 
        <p>Para realizar esta preparación, se deben tener en cuenta los siguientes aspectos:</p>  
        <!-- <v-layout  v-for="n in 4" :key="`card-${n}`" align-center>
            <v-flex md2>                                                                                                                                                                                                                                                                                                                                                     
              <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-6-'+n+'.png')" alt="">
            </v-flex>
            <v-flex md9 xs12 ml-2> 
              <span class="items" v-html="items[n-1]"></span>
            </v-flex>  
        </v-layout> -->
        <v-layout wrap row  align-center text-xs-center justify-center pb-5 mt-4 class="cont_page">
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-2" src="@/assets/unidad2/pantalla-6-1.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-3 text-xs-center">Aplicar los Aislamientos Seguros (SAS Y SAES) si aplica.</p>
                    <hr class="animated bounceIn dura-3">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-4" src="@/assets/unidad2/pantalla-6-2.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-5 text-xs-center">Realizar una <strong>revisión minuciosa</strong> de áreas y equipos con el fin de neutralizar cualquier posibilidad de entrada de gases peligrosos.</p>
                    <hr class="animated bounceIn dura-5">
                </v-flex>
                <v-flex sm12 md12></v-flex>
    
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad2/pantalla-6-3.png" alt="">
                </v-flex>
                <scrolldown-app></scrolldown-app>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-7 text-xs-center">Revisar <strong>fuentes externas</strong> que pueden aportar gases peligrosos como colectores de aguas aceitosas, venteos, sistemas de relevo, etc.</p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad2/pantalla-6-4.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-7 text-xs-center">Analizar la presencia de sustancias o materiales que pudieran <strong>emitir gases</strong> o vapores con el trabajo a realizar.</p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
            </v-layout>
    </v-flex>
    <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
        <span><strong>Recuerda </strong></span> 
        <p> El espacio debe estar <strong>libre de gases</strong>, líquidos o vapores combustibles. Para ello, debe buscarse en sitios donde puedan estar, sin ser muy obvios, como en soportes, 
            columnas y pisos, en el caso de tanques o recipientes.  Los demás espacios deberán ser monitoreados y garantizadas condiciones de seguridad antes de permitir cualquier entrada. </p>
        <p> La prueba de gas debe efectuarse desde el exterior o desde una zona segura e ir avanzando hasta cubrir la totalidad del espacio. </p>
    </v-flex>
    <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
        <span><strong>Video de caso real de un incidente durante una prueba de gases  </strong></span> 
        <p> La entrada para monitorear el espacio confinado es muy riesgosa y por ello se deben tomar las precauciones correspondientes al más peligroso de los espacios hasta que no se demuestre objetivamente lo contrario. </p>
        <p> El siguiente video muestra un incidente durante este proceso: </p>
        <p class="instruccion">Haz clic para ver el video</p>
        <v-layout wrap justify-center align-center>
          <v-flex xs12 sm7 md7 mt-3 >
            <!-- <iframe width="100%" height="300px" src="https://www.youtube.com/embed/5HvsUS7MuP8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          <video :src="videoYoutube" buffered controls 
                       :width="widthVideo" 
                       :height="heightVideo" 
                       @ended="mostrarCerrar2=true" 
          ></video>
          <p class="text-xs-center">Botta, N. A. (2020, Octubre 5).<i> Explosión en un Espacio Confinado.</i> Obtenido de YouTube: https://www.youtube.com/watch?v=hmuOQKWhi0Y</p>
          </v-flex>
        </v-layout>
      <v-layout wrap row  align-center text-xs-center pb-5 mt-4 class="cont_page">
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-2" src="@/assets/unidad2/pantalla-6-5.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-3">Orden de muestreo: oxígeno, gas o vapor inflamable, gases tóxicos</p>
                    <hr class="animated bounceIn dura-3">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-4" src="@/assets/unidad2/pantalla-6-6.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-5">Monitoreo con la frecuencia establecida</p>
                    <hr class="animated bounceIn dura-5">
                </v-flex>
                <v-flex sm12 md12></v-flex>
    
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad2/pantalla-6-7.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-7">Uso de equipos confiables</p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
            </v-layout>
      <!-- <v-flex>
          <v-layout align-center mt-2>
          <v-flex md2  xs2>
          <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-6-5.png')" alt="">
          </v-flex>
          <v-flex >
            <p>Orden de muestreo: oxígeno, gas o vapor inflamable, gases tóxicos</p>
          </v-flex>
          </v-layout>
      </v-flex> -->
      <!-- <v-layout  v-for="n in 3" :key="`card-${n}`" align-center justify-center>
            <v-flex md9 xs7 ml-1> 
              <li>
                  <span class="items" v-html="items2[n-1]"></span>
              </li>
              
            </v-flex>  
    </v-layout> -->
    <!-- <v-flex>
          <v-layout align-center mt-2>
          <v-flex md2 xs2 >
          <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-6-6.png')" alt="">
          </v-flex>
          <v-flex > 
            <p>Monitoreo con la frecuencia establecida </p>
          </v-flex>
          </v-layout>
      </v-flex>
      <v-flex>
          <v-layout align-center mt-2>
          <v-flex md2 xs2>
          <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-6-7.png')" alt="">
          </v-flex>
          <v-flex >
            <p>Uso de equipos confiables </p>
          </v-flex>
          </v-layout>
      </v-flex> -->
      <v-flex>
          <p>Aunque el detector realiza la lectura de todas las sustancias de forma simultánea, la clave está en el orden en que se reconoce el riesgo.  La mayoría de detectores necesitan el oxígeno para proporcionar datos confiables </p>
          <span><strong>Prueba por niveles </strong></span> 
        <p>Se deben tomar varias muestras en diferentes niveles</p>
        <p>Es sumamente importante conocer las características del contaminante real o potencial que contiene el Espacio Confinado, con el fin de determinar su densidad relativa, es decir si pesa más o menos que el aire, para detectar donde puede estar concentrado, y hacer más efectiva la medición </p>
        <v-layout wrap justify-center align-center>
        <v-flex xs12 sm7 md7 mt-3  v-show="!$vuetify.breakpoint.xs">
          <svg-app></svg-app > 
        <!-- <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-6-8.png')" alt=""> -->
        </v-flex>
        <v-flex xs12 sm9 md7 mt-4 fill-height text-xs-center class="animated fadeInUp dura-1" v-show="$vuetify.breakpoint.xs">
        <p>
          <span class="instruccion">Haz clic en el icono para ver el diagrama.</span>  
        </p>
        <button class="hvr hvr-hover btn-img--wb">
          <a href="documents/unidad2/pantalla6.pdf" target="_blank">
            <img class="img-center" src="../../assets/imagenes_compartidas/boton-descarga.png" alt="">            
          </a>
        </button>
      </v-flex>
        </v-layout>
        <!-- <button class="hvr hvr-hover btn-img--wb">
                <a href="documents/unidad-1/pantalla-10.pdf" target="_blank">
                  <img class="img-center" src="../../assets/imagenes_compartidas/icon-descarga.svg" alt="">            
                </a>
        </button> -->
        <p>Recuerda revisar el manual del fabricante.</p>
        <p>Los siguientes videos explican el comportamiento del vapor liviano y del vapor pesado.</p>
        <p class="instruccion">Haz clic en cada botón para reproducir los videos.</p>
        <span>
          <strong>Vapor Liviano </strong>
        </span><br>
        <v-layout wrap justify-center align-center>
          <v-flex xs12 sm7 md7 mt-3 >
             <video :src="videoYoutube2" buffered controls 
                       :width="widthVideo" 
                       :height="heightVideo" 
                       @ended="mostrarCerrar2=true" 
          ></video>
          <p class="text-xs-center"><i>Fuente: Ecopetrol</i></p>
          </v-flex>
        </v-layout>
        <span>
          <strong>Vapor Pesado </strong>
        </span><br>
        <v-layout wrap justify-center align-center>
          <v-flex xs12 sm7 md7 mt-3 >
             <video :src="videoYoutube3" buffered controls 
                       :width="widthVideo" 
                       :height="heightVideo" 
                      @ended="validarVisto()"
          ></video>
          <p class="text-xs-center"><i>Fuente: Ecopetrol</i></p>
          </v-flex>
        </v-layout>
        <span><strong>Reglas de muestreo</strong></span><br>
        <v-flex text-xs-center> 
          <img class="animated flipInY dura-1 " :src="require('../../assets/unidad2/pantalla-6-9.png')" alt="">
        </v-flex>
        <!-- <v-layout  class="flip-item" v-for="n in 4" :key="`card-${n}`" align-center mt-3>
            <v-flex md1 mr-2> 
              <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla6-'+n+'.png')" alt="">
            </v-flex>
            <v-flex md7 xs10> 
              <span class="items" v-html="items3[n-1]"></span>
            </v-flex>  
          </v-layout>  -->
          <v-layout wrap row  align-center text-xs-center pb-5 mt-4 class="cont_page">
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-2" src="@/assets/unidad2/pantalla6-1.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-3"><strong>Máxima Distancia de 30 m</strong> con manguera 1/8 Tygon o 3/8 Teflón.</p>
                    <hr class="animated bounceIn dura-3">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-4" src="@/assets/unidad2/pantalla6-2.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-5"><strong>Regla de Muestreo del 5 por 1.5</strong> segundos por metro (requerimiento mínimo).</p>
                    <hr class="animated bounceIn dura-5">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad2/pantalla6-3.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-7"><strong>30 segundos de tiempo de muestreo</strong> (respuesta del sensor).</p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad2/pantalla6-4.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-7"><strong>Muestreo en Espacio Confinado</strong> Arriba, Medio y Fondo (mínimo a intervalos de 4 pies según OSHA).</p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
            </v-layout>
      </v-flex>
    </v-flex>
    </v-layout>
  </div>  
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import svg from "./svg/pantalla6";
export default {
  components: {
    "svg-app": svg,
  },
  mixins: [nextConditions],
  data() {
    return {
        items:[
        'Aplicar los Aislamientos Seguros (SAS Y SAES) si aplica.',
        'Realizar una <strong>revisión minuciosa</strong> de áreas y equipos con el fin de neutralizar cualquier posibilidad de entrada de gases peligrosos.  ',
        'Revisar <strong>fuentes externas</strong> que pueden aportar gases peligrosos como colectores de aguas aceitosas, venteos, sistemas de relevo, etc.  ',
        'Analizar la presencia de sustancias o materiales que pudieran <strong>emitir gases</strong> o vapores con el trabajo a realizar. '
        ],
        items2:[
            'Oxígeno ',
            'Gas o vapor inflamable ',
            'Gases tóxicos ',
        ],
        items3:[
            '<strong>Máxima Distancia de 30 m</strong> con manguera 1/8 Tygon o 3/8 Teflón.',
            '<strong>Regla de Muestreo del 5 por 1.5</strong> segundos por metro (requerimiento mínimo).',
            '<strong>30 segundos de tiempo de muestreo</strong> (respuesta del sensor).',
            '<strong>Muestreo en Espacio Confinado</strong> Arriba, Medio y Fondo (mínimo a intervalos de 4 pies según OSHA).'
        ],
        widthVideo:'100%',
        //heightVideo:'300px',
        //videoId:'N3Z_ItJuyjc',
        videoYoutube:'./videos/Soldadura.mp4',
        videoYoutube2:'./videos/Vapor Liviano.mp4',
        videoYoutube3:'./videos/Vapor Pesado.mp4'
      
    }
  },
  mounted() {
    setTimeout(() => {
       this.$store.commit('nextShow', true);
    },6000);
  },  
  validarVisto(){
        this.$store.commit('nextShow', true)
},
}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';
.items{
  font-size: 13.6px;
}
@media screen and (max-width: 500px){
.contenido2{
  display: flex;
  flex-direction: column;
  align-items: center;
}
}
hr {
    height: 2px;
    background-color: $color-complement-one;
    border: none;
    margin-bottom: 1em;
}
</style>
